import {
  GridActionsCellItem,
  GridActionsColDef,
  GridColDef,
  GridRowParams,
} from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import "./TableActions.css";

// Columna alineada a la izquierda (el tema centra el resto por defecto)
export const alignLeft: Partial<GridColDef> = {
  align: "left",
  headerAlign: "left",
  cellClassName: "aedasCell--left",
};

type ActionsColumnOptions = {
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  // Para deshabilitar la acción en algunas filas (p. ej. sobre el propio usuario)
  canEdit?: (row: any) => boolean;
  canDelete?: (row: any) => boolean;
};

// Columna de acciones con iconos, como en el resto de proyectos AEDAS
// (GridActionsCellItem + botón de icono sin fondo). Borrar siempre al final.
export const actionsColumn = ({ onEdit, onDelete, canEdit, canDelete }: ActionsColumnOptions): GridActionsColDef => ({
  field: "actions",
  type: "actions",
  headerName: "Acciones",
  width: 120,
  align: "right",
  headerAlign: "right",
  // El Tooltip va dentro de "icon": GridActionsCellItem no reenvía refs en esta versión
  getActions: (params: GridRowParams) => [
    <GridActionsCellItem
      key={`edit-${params.id}`}
      id={`edit-button-${params.id}`}
      className="aedasIconAction"
      icon={
        <Tooltip title="Editar">
          <EditIcon />
        </Tooltip>
      }
      label="Editar"
      disabled={canEdit ? !canEdit(params.row) : false}
      onClick={() => onEdit(params.row)}
    />,
    <GridActionsCellItem
      key={`delete-${params.id}`}
      id={`delete-button-${params.id}`}
      className="aedasIconAction aedasIconAction--delete"
      icon={
        <Tooltip title="Borrar">
          <DeleteIcon />
        </Tooltip>
      }
      label="Borrar"
      disabled={canDelete ? !canDelete(params.row) : false}
      onClick={() => onDelete(params.row)}
    />,
  ],
});
